import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaTimePicker from './VaTimePicker.vue'

export const VaTimePicker = withConfigTransport(_VaTimePicker)
